export async function selectText(el: HTMLElement): Promise<void> {
  const selection = window.getSelection();
  if (!selection) return;

  if (selection.toString() === '') {
    const range = document.createRange();
    range.selectNodeContents(el);
    selection.removeAllRanges();
    selection.addRange(range);
  }
}
